document.addEventListener('DOMContentLoaded', function () {
  const root = document.querySelector('[data-wa-quote-root]') || document.querySelector('[data-sakura-chat-root]');
  if (!root) return;

  const toggle = root.querySelector('[data-wa-toggle]');
  const drawer = root.querySelector('[data-wa-drawer]');
  const backdrop = root.querySelector('[data-wa-backdrop]');
  const closeBtn = root.querySelector('[data-wa-close]');

  const nameInput = root.querySelector('[data-wa-name]');
  const companyInput = root.querySelector('[data-wa-company]');
  const cnpjInput = root.querySelector('[data-wa-cnpj]');

  const selectedList = root.querySelector('[data-wa-selected-list]');
  const counter = root.querySelector('[data-wa-counter]');
  const feedbackEl = root.querySelector('[data-wa-feedback]');
  const sendBtn = root.querySelector('[data-wa-send]');

  // Modal de frete
  const freightModal = document.querySelector('[data-wa-freight-modal]');
  const freightBackdrop = freightModal && freightModal.querySelector('[data-wa-freight-backdrop]');
  const freightCheck = freightModal && freightModal.querySelector('[data-wa-freight-check]');
  const freightConfirm = freightModal && freightModal.querySelector('[data-wa-freight-confirm]');
  const freightCancel = freightModal && freightModal.querySelector('[data-wa-freight-cancel]');

  const searchInput = root.querySelector('.wa-quote-search-input');
  const resultsContainer = root.querySelector('.predictive-search--wa-quote');
  const resetBtn = root.querySelector('[data-wa-search-reset]');

  const waNumberRaw = (root.getAttribute('data-whatsapp-number') || '').trim();

  const MAX_PRODUCTS = 5;
  const selectedProducts = [];
  let searchTimeout = null;

  /* ---------- UTILS ---------- */

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function escapeHtmlAttr(str) {
    return escapeHtml(str).replace(/`/g, '&#96;');
  }

  function showFeedback(message) {
    if (!feedbackEl) return;
    feedbackEl.textContent = message || '';
  }

  function clearFeedback() {
    if (!feedbackEl) return;
    feedbackEl.textContent = '';
  }

  function updateCounter() {
    if (!counter) return;
    counter.textContent = selectedProducts.length + '/' + MAX_PRODUCTS + ' selecionados';
  }

  /* ---------- CNPJ: FORMATAÇÃO + VALIDAÇÃO ---------- */

  function formatCNPJ(value) {
    let digits = (value || '').replace(/\D/g, '').slice(0, 14);
    let out = '';

    if (digits.length > 0) out += digits.slice(0, 2);
    if (digits.length >= 3) out += '.' + digits.slice(2, 5);
    if (digits.length >= 6) out += '.' + digits.slice(5, 8);
    if (digits.length >= 9) out += '/' + digits.slice(8, 12);
    if (digits.length >= 13) out += '-' + digits.slice(12, 14);

    return out;
  }

  function isValidCNPJ(value) {
    let cnpj = (value || '').replace(/\D/g, '');
    if (!cnpj || cnpj.length !== 14) return false;

    // Elimina CNPJs inválidos conhecidos
    if (/^(\d)\1+$/.test(cnpj)) return false;

    let length = cnpj.length - 2;
    let numbers = cnpj.substring(0, length);
    let digits = cnpj.substring(length);
    let sum = 0;
    let pos = length - 7;

    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }

    let result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result != digits.charAt(0)) return false;

    length = length + 1;
    numbers = cnpj.substring(0, length);
    sum = 0;
    pos = length - 7;
    for (let i = length; i >= 1; i--) {
      sum += numbers.charAt(length - i) * pos--;
      if (pos < 2) pos = 9;
    }
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result != digits.charAt(1)) return false;

    return true;
  }

  if (cnpjInput) {
  cnpjInput.addEventListener('input', function () {
    // mantém só os dígitos
    const digits = cnpjInput.value.replace(/\D/g, '').slice(0, 14);
    // formata bonitinho
    const formatted = formatCNPJ(digits);
    cnpjInput.value = formatted;

    // força o cursor SEMPRE pro final
    try {
      const endPos = cnpjInput.value.length;
      cnpjInput.setSelectionRange(endPos, endPos);
    } catch (e) {}
  });

  cnpjInput.addEventListener('blur', function () {
    const digits = cnpjInput.value.replace(/\D/g, '');
    if (!digits) {
      clearFeedback();
      return;
    }
    if (!isValidCNPJ(digits)) {
      showFeedback('Digite um CNPJ válido.');
    } else {
      clearFeedback();
    }
  });
}
  /* ---------- DRAWER (ABRE / FECHA) ---------- */

  function openDrawer() {
    root.classList.add('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'true');
    if (drawer) drawer.setAttribute('aria-hidden', 'false');
  }

  function closeDrawer() {
    root.classList.remove('is-open');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
    if (drawer) drawer.setAttribute('aria-hidden', 'true');
  }

  /* ---------- LISTA DE PRODUTOS SELECIONADOS ---------- */

  function renderSelected() {
    if (!selectedList) return;

    if (!selectedProducts.length) {
      selectedList.innerHTML = '';
      updateCounter();
      return;
    }

    selectedList.innerHTML = selectedProducts
      .map(function (p, index) {
        const skuText = p.sku ? ' (SKU: ' + escapeHtml(p.sku) + ')' : '';
        return (
          '<li class="wa-quote-selected__item">' +
            '<span class="wa-quote-selected__label">' +
              (index + 1) + ') ' + escapeHtml(p.title) + skuText +
            '</span>' +
            '<button type="button" class="wa-quote-selected__remove" ' +
              'data-wa-remove data-product-url="' + escapeHtmlAttr(p.url) + '">' +
              'Remover' +
            '</button>' +
          '</li>'
        );
      })
      .join('');

    updateCounter();
  }

  function addProductFromElement(buttonEl) {
    const url = buttonEl.getAttribute('data-product-url');
    const title = buttonEl.getAttribute('data-product-title') || '';
    if (!url || !title) return;

    if (selectedProducts.length >= MAX_PRODUCTS) {
      showFeedback('Você já selecionou o máximo de ' + MAX_PRODUCTS + ' produtos.');
      return;
    }

    // evita duplicados
    const already = selectedProducts.some(function (p) {
      return p.url === url;
    });
    if (already) {
      showFeedback('Esse produto já foi adicionado.');
      return;
    }

    selectedProducts.push({
      url: url,
      title: title,
      sku: '' // vamos tentar preencher depois
    });
    renderSelected();
    updateCounter();

    // tenta buscar SKU depois sem travar a interface
    fetchSkuForSelected(url);
  }

  function removeProduct(url) {
    for (let i = 0; i < selectedProducts.length; i++) {
      if (selectedProducts[i].url === url) {
        selectedProducts.splice(i, 1);
        break;
      }
    }
    renderSelected();
    updateCounter();
  }

  /* ---------- BUSCA / SUGESTÕES ---------- */

  function clearResults() {
    if (resultsContainer) resultsContainer.innerHTML = '';
  }

  function renderResults(products) {
    if (!resultsContainer) return;

    if (!products.length) {
      resultsContainer.innerHTML =
        '<div class="predictive-search__empty">Nenhum produto encontrado.</div>';
      return;
    }

    let itemsHtml = '';
    products.forEach(function (p) {
      const title = escapeHtml(p.title || 'Produto');
      const url = escapeHtmlAttr(p.url || '#');
      const vendor = p.vendor ? escapeHtml(p.vendor) : '';

      itemsHtml +=
        '<button type="button" class="predictive-search__item wa-quote-result" ' +
          'data-wa-product data-product-url="' + url + '" ' +
          'data-product-title="' + title + '">' +
          '<div class="predictive-search__item-content">' +
            '<h3 class="predictive-search__item-heading">' + title + '</h3>' +
            (vendor
              ? '<p class="predictive-search__item-vendor">' + vendor + '</p>'
              : ''
            ) +
          '</div>' +
          '<span class="wa-quote-result__action">Selecionar</span>' +
        '</button>';
    });

    resultsContainer.innerHTML = itemsHtml;

    // cliques para selecionar produto
    resultsContainer.querySelectorAll('[data-wa-product]').forEach(function (btn) {
      btn.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        addProductFromElement(btn);
        clearResults();
        if (searchInput) searchInput.value = '';
        clearFeedback();
      });
    });
  }

  function performSearch(term) {
    if (!resultsContainer) return;

    term = (term || '').trim();
    if (!term) {
      clearResults();
      return;
    }

    const endpoint = '/search/suggest.json';
    const url =
      endpoint +
      '?q=' + encodeURIComponent(term) +
      '&resources[type]=product' +
      '&resources[limit]=20' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor';

    resultsContainer.innerHTML =
      '<div class="predictive-search__empty">Buscando…</div>';

    fetch(url, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Erro na busca');
        return response.json();
      })
      .then(function (data) {
        const products =
          data.resources &&
          data.resources.results &&
          data.resources.results.products
            ? data.resources.results.products
            : [];
        renderResults(products);
      })
      .catch(function (err) {
        console.error('Erro na busca do WhatsApp drawer:', err);
        resultsContainer.innerHTML =
          '<div class="predictive-search__empty">Erro ao buscar produtos.</div>';
      });
  }

  if (searchInput) {
    searchInput.addEventListener('input', function () {
      const term = searchInput.value.trim();
      clearFeedback();
      if (searchTimeout) clearTimeout(searchTimeout);
      searchTimeout = setTimeout(function () {
        performSearch(term);
      }, 250);
    });

    // bloqueia Enter pra não mandar o form de busca do tema
    searchInput.addEventListener('keydown', function (event) {
      if (event.key === 'Enter') {
        event.preventDefault();
      }
    });
  }

  if (resetBtn) {
    resetBtn.addEventListener('click', function () {
      if (searchInput) searchInput.value = '';
      clearResults();
      clearFeedback();
    });
  }

  /* ---------- BUSCA DE SKU EXTRA POR PRODUTO ---------- */

  function extractHandleFromUrl(url) {
    try {
      const u = new URL(url, window.location.origin);
      const parts = u.pathname.split('/').filter(Boolean);
      const idx = parts.indexOf('products');
      if (idx !== -1 && parts[idx + 1]) {
        return parts[idx + 1];
      }
    } catch (e) {
      console.warn('Não foi possível extrair handle do produto:', url, e);
    }
    return null;
  }

  function fetchSkuForSelected(url) {
    const handle = extractHandleFromUrl(url);
    if (!handle) return;

    fetch('/products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (resp) {
        if (!resp.ok) throw new Error('Erro ao buscar produto .js');
        return resp.json();
      })
      .then(function (productData) {
        const variants = productData && productData.variants ? productData.variants : [];
        const sku = variants[0] && variants[0].sku ? variants[0].sku : '';
        if (!sku) return;

        selectedProducts.forEach(function (p) {
          if (p.url.indexOf('/products/' + handle) !== -1) {
            p.sku = sku;
          }
        });
        renderSelected();
      })
      .catch(function (err) {
        console.warn('Erro ao buscar SKU do produto selecionado:', err);
      });
  }

  /* ---------- MODAL DE FRETE ---------- */

  function openFreightModal() {
    if (!freightModal) return;
    freightModal.classList.add('is-open');
    freightModal.setAttribute('aria-hidden', 'false');
    if (freightCheck) freightCheck.checked = false;
    if (freightConfirm) freightConfirm.disabled = true;
  }

  function closeFreightModal() {
    if (!freightModal) return;
    freightModal.classList.remove('is-open');
    freightModal.setAttribute('aria-hidden', 'true');
  }

  if (freightCheck && freightConfirm) {
    freightCheck.addEventListener('change', function () {
      freightConfirm.disabled = !freightCheck.checked;
    });
  }

  if (freightBackdrop) {
    freightBackdrop.addEventListener('click', closeFreightModal);
  }

  if (freightCancel) {
    freightCancel.addEventListener('click', closeFreightModal);
  }

  if (freightConfirm) {
    freightConfirm.addEventListener('click', function () {
      closeFreightModal();
      doSend();
    });
  }

  /* ---------- ENVIO PARA WHATSAPP ---------- */

  // Dados pendentes aguardando confirmação no modal
  let pendingSendData = null;

  function doSend() {
    if (!pendingSendData) return;
    const { waNumber, name, company, cnpjDigits } = pendingSendData;
    pendingSendData = null;

    const lines = [];

    if (selectedProducts.length) {
      lines.push('Olá vim do site da Distribuidora Sakura, gostaria de tirar algumas dúvidas sobre os produtos abaixo.');
    } else {
      lines.push('Olá vim do site da Distribuidora Sakura, gostaria de tirar algumas dúvidas.');
    }

    lines.push('');
    lines.push('Nome: ' + name);
    lines.push('Razão social: ' + (company || '-'));
    lines.push('CNPJ: ' + formatCNPJ(cnpjDigits));
    lines.push('');

    if (selectedProducts.length) {
      lines.push('Produtos selecionados:');

      selectedProducts.forEach(function (p, index) {
        const skuText = p.sku ? ' (SKU: ' + p.sku + ')' : '';
        lines.push((index + 1) + ') ' + p.title + skuText);
      });
    }

    const text = encodeURIComponent(lines.join('\n'));
    const waUrl = 'https://wa.me/' + waNumber + '?text=' + text;
    window.open(waUrl, '_blank', 'noopener');
  }

  async function handleSend() {
    clearFeedback();

    const waNumber = waNumberRaw.replace(/\D/g, '');
    if (!waNumber) {
      showFeedback('Número do WhatsApp não configurado nas configurações do tema.');
      return;
    }

    const name = nameInput && nameInput.value ? nameInput.value.trim() : '';
    const company = companyInput && companyInput.value ? companyInput.value.trim() : '';
    const cnpjDigits = cnpjInput && cnpjInput.value
      ? cnpjInput.value.replace(/\D/g, '')
      : '';

    if (!name) {
      showFeedback('Preencha o campo Nome.');
      return;
    }

    if (!company) {
      showFeedback('Preencha o campo Razão social.');
      return;
    }

    if (!cnpjDigits) {
      showFeedback('Preencha o campo CNPJ.');
      return;
    }

    if (!isValidCNPJ(cnpjDigits)) {
      showFeedback('Digite um CNPJ válido.');
      return;
    }

    // Bloqueia envio e consulta Receita Federal
    sendBtn.disabled = true;
    sendBtn.textContent = 'Verificando CNPJ...';

    try {
      const workerUrl = document.querySelector('[data-sakura-chat-root]')
        ? 'https://validar-cnpj.aquariosakuraimports.workers.dev'
        : null;

      if (workerUrl) {
        const resp = await fetch(workerUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ cnpj: cnpjDigits }),
        });

        const data = await resp.json();

        if (!data.ok) {
          showFeedback('CNPJ inválido.');
          sendBtn.disabled = false;
          sendBtn.textContent = 'ENVIAR PARA WHATSAPP';
          return;
        }
      }
    } catch (err) {
      // Se o Worker falhar, deixa passar para não bloquear o atendimento
      console.warn('Erro ao validar CNPJ no Worker:', err);
    }

    sendBtn.disabled = false;
    sendBtn.textContent = 'ENVIAR PARA WHATSAPP';
    clearFeedback();

    // Salva dados e abre modal de confirmação de frete
    pendingSendData = { waNumber, name, company, cnpjDigits };
    openFreightModal();
  }

  /* ---------- LISTENERS GERAIS ---------- */

  if (toggle) {
    toggle.addEventListener('click', function () {
      if (root.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });
  }

  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  if (backdrop) backdrop.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && root.classList.contains('is-open')) {
      closeDrawer();
    }
  });

  if (sendBtn) sendBtn.addEventListener('click', handleSend);

  if (selectedList) {
    selectedList.addEventListener('click', function (event) {
      const btn = event.target.closest('[data-wa-remove]');
      if (!btn) return;
      const url = btn.getAttribute('data-product-url');
      if (!url) return;
      removeProduct(url);
    });
  }

  updateCounter();
});